module.exports = __webpack_public_path__ + "img/asset_GST.cd066c2e.svg";